module.exports = __webpack_public_path__ + "img/cloud-lightning-sun.f9ea3b72.svg";